import { PopupMenuItem } from './popup-menu-item.model';

export class ColoredPopupMenuItem extends PopupMenuItem
{
    klass: 'danger' | 'warning2' | 'warning1' | 'info' | 'success' | 'blue';
}
